import React, { PureComponent } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'

import Panel from '../../../../UniformComponents/Panel'
import RadioGroup from '../../../form/RadioGroup'
import Store from './store'
import Input from '../../../form/Input'
import Select from '../../../form/Select'
import Anchor from '../../../../UniformComponents/Anchor'
import Loader from '../Loader'

import './moveProductOrPortfolio.scss'
import Button from '../../../../UniformComponents/Button'

@observer
class MoveProductOrPortfolio extends PureComponent {
    constructor(props) {
        super(props)

        this.store = new Store(props.store)
    }

    componentDidMount() {
        const { store } = this.props
        store.breadcrumps = [
            {
                name: 'intranet',
                url: '/intranet',
                title: 'Intranet',
            },
            {
                name: 'moveProductOrPortfolioToNewClient',
                url: '/intranet/moveProductOrPortfolioToNewClient',
                title: 'Move product or portfolio to a new client',
            },
        ]

        this.store.getClients()
    }

    renderLink = () => {
        const { store } = this
        const { dataviewerLink } = store

        if (R.isNil(dataviewerLink)) return null

        return (
            <Anchor
                isExternal
                target="_blank"
                cssClass="tableButton"
                href={dataviewerLink}
            >
                You can check change status here
            </Anchor>
        )
    }

    render() {
        const { store } = this

        const { loading, type } = store

        if (loading) return null

        return (
            <>
                <Loader show={store.processing} />
                <Panel cssClass="moveProductOrPortfolio">
                    {this.renderLink()}
                    <RadioGroup
                        name="type"
                        label="Type"
                        options={store.types}
                        onBlur={store.changeType}
                        defaultChecked={store.type}
                    />
                    <Input
                        name="id"
                        label="Id"
                        onChange={store.changeId}
                        value={store.id}
                    />
                    {type === 'product' && (
                        <Input
                            name="portfolioId"
                            label="Move to portfolioId"
                            onChange={store.changePortfolioId}
                            value={store.portfolioId}
                        />
                    )}
                    {type === 'portfolio' && (
                        <Select
                            name="clientId"
                            label="Move to client"
                            onBlur={store.changeClientId}
                            value={store.clientId}
                            options={store.clients}
                        />
                    )}
                    <div className="buttons">
                        <Button
                            label="Move"
                            cssClass="regular primary"
                            onClick={store.move}
                        />
                    </div>
                </Panel>
            </>
        )
    }
}

export default MoveProductOrPortfolio
